import * as React from 'react';
import * as styles from './PublishPaymentStatus.css';
import { PaymentStatusCanceledContainer, PaymentStatusPending } from './components';
import { EPaymentStatus } from '../../types/reducers/paymentProcessing';

interface IProps {
  status: EPaymentStatus;
}

export const PublishPaymentStatus = (props: IProps) => {
  const { status } = props;

  return (
    <div className={styles['wrapper']}>
      {status === EPaymentStatus.Pending && <PaymentStatusPending />}

      {status === EPaymentStatus.Canceled && <PaymentStatusCanceledContainer />}
    </div>
  );
};
